<template>
  <v-sheet class="front-root">
    <v-sheet max-width="580" class="front-canvas mx-auto">
      <div v-if="hasHeader" class="front-edge-gradient front-edge-gradient--top" aria-hidden="true"></div>
      <div v-if="isMenu" class="front-edge-gradient front-edge-gradient--bottom" aria-hidden="true"></div>
      <Header />
      <router-view class="front-view" :class="{ 'front-view--with-header': hasHeader, 'front-view--with-footer': isMenu }" :key="$route.fullPath"></router-view>
      <Footer />
    </v-sheet>
  </v-sheet>
</template>

<script>
import Header from "./Header"
import Footer from "./Footer"
import { isMenuPage } from "@/constant"

export default {
  components: {
    Header,
    Footer,
  },
  mounted() {
    const viewport = document.querySelector('meta[name="viewport"]')
    if (!viewport) return
    const content = viewport.getAttribute("content") || "width=device-width, initial-scale=1"
    if (!content.includes("viewport-fit")) {
      viewport.setAttribute("content", `${content}, viewport-fit=cover`)
    }
  },
  computed: {
    hasHeader() {
      return this.$route.path !== "/website_youtube_link"
    },
    isMenu() {
      return isMenuPage(this.$route.path)
    },
  },
}
</script>

<style scoped>
.front-root {
  min-height: 100%;
  background: #f4f1f3 !important;
}
.front-canvas {
  position: relative;
  min-height: 100vh;
  overflow-x: clip;
  background: white !important;
  box-shadow: 0 0 24px rgba(69, 48, 57, 0.12);
}
.front-edge-gradient {
  position: fixed;
  right: 0;
  left: 0;
  z-index: 80;
  width: 100%;
  max-width: 580px;
  margin-right: auto;
  margin-left: auto;
  pointer-events: none;
}
.front-edge-gradient--top {
  top: 0;
  height: calc(68px + env(safe-area-inset-top, 0px));
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.9) 0%,
    rgba(255, 255, 255, 0.7) 34%,
    rgba(255, 255, 255, 0.28) 66%,
    rgba(255, 255, 255, 0) 100%
  );
}
.front-edge-gradient--bottom {
  bottom: 0;
  height: calc(82px + env(safe-area-inset-bottom, 0px));
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 0.9) 0%,
    rgba(255, 255, 255, 0.68) 36%,
    rgba(255, 255, 255, 0.28) 68%,
    rgba(255, 255, 255, 0) 100%
  );
}
.front-view {
  box-sizing: border-box;
  min-height: 100vh;
  margin-bottom: 0 !important;
}
.front-view--with-header {
  padding-top: calc(58px + env(safe-area-inset-top, 0px)) !important;
}
.front-view--with-footer {
  padding-bottom: calc(66px + env(safe-area-inset-bottom, 0px)) !important;
}
@supports not (overflow: clip) {
  .front-canvas {
    overflow-x: hidden;
  }
}
</style>
